module.exports = __webpack_public_path__ + "static/img/logo.fbb27080.png";